(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wsm-card-image-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wsm-product-card')) {
    customElements.define('wsm-product-card', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const swatch = event.target.closest('.wsm-card-swatch');
          if (!swatch || !this.contains(swatch)) return;
          event.preventDefault();
          event.stopPropagation();
          this.previewColour(swatch);
        }, { signal: this.controller.signal });
      }
      previewColour(swatch) {
        const picture = this.querySelector('a.card__media picture');
        const image = picture?.querySelector('img');
        if (!image || !swatch.dataset.image) return;
        const revision = this.revision = (this.revision || 0) + 1;
        const preload = new Image();
        preload.onload = () => {
          if (revision !== this.revision || !this.isConnected) return;
          picture.querySelectorAll('source').forEach(source => { source.srcset = swatch.dataset.imageSrcset || swatch.dataset.image; });
          image.srcset = swatch.dataset.imageSrcset || '';
          image.src = swatch.dataset.image;
          image.alt = swatch.dataset.imageAlt || '';
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
          picture.dataset.hq = swatch.dataset.imageHq || swatch.dataset.image;
          const frame = picture.closest('.card--image-animate');
          if (frame) frame.style.display = '';
          this.classList.add('wsm-card-image-selected');
          this.querySelectorAll('.wsm-card-swatch').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
          if (swatch.dataset.productUrl) {
            this.querySelectorAll('a.card__media, a.card-information__text, .card-information > a.full-unstyled-link, a.card__colors-more').forEach(link => { link.href = swatch.dataset.productUrl; });
          }
        };
        preload.src = swatch.dataset.image;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.revision = (this.revision || 0) + 1;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wsm-in-store-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wsm-in-store-availability')) {
    const cache = new Map();
    const productAvailability = new WeakMap();
    const queue = [];
    let active = 0;

    function processQueue() {
      while (active < 3 && queue.length) {
        active++;
        queue.shift()().finally(() => {
          active--;
          processQueue();
        });
      }
    }

    function checkStock(variantId, refresh = false) {
      if (refresh) cache.delete(variantId);
      if (!cache.has(variantId)) {
        const request = new Promise((resolve, reject) => {
          queue.push(async () => {
            try {
              const root = window.Shopify?.routes?.root || '/';
              const response = await fetch(`${root}variants/${encodeURIComponent(variantId)}/?section_id=pickup-availability`, {
                credentials: 'same-origin',
                signal: AbortSignal.timeout(15000)
              });
              if (!response.ok) throw new Error('Availability request failed');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const stock = html.querySelector('[data-wsm-in-store-quantity]');
              if (!stock) throw new Error('Shop stock reader missing');
              const raw = stock.dataset.wsmInStoreQuantity;
              resolve(/^\d+$/.test(raw) ? Number(raw) : null);
            } catch (error) {
              cache.delete(variantId);
              reject(error);
            }
          });
        });
        cache.set(variantId, request);
        processQueue();
      }
      return cache.get(variantId);
    }

    function updateProductBanner(element, available) {
      const scope = element.closest('product-info') || element.closest('form') || element.parentElement;
      if (!scope) return;
      if (!productAvailability.has(scope)) productAvailability.set(scope, new Map());
      const variants = productAvailability.get(scope);
      if (typeof available === 'boolean') variants.set(element.dataset.variantId, available);
      const anyAvailable = Array.from(variants.values()).some(Boolean);
      scope.querySelectorAll('[data-store-banner]').forEach(banner => { banner.hidden = !anyAvailable; });
    }

    customElements.define('wsm-in-store-availability', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.variantId || this.observer) return;
        const raw = this.dataset.initialQuantity;
        this.quantity = /^\d+$/.test(raw || '') ? Number(raw) : null;
        this.setRowState(this.hasAttribute('data-initial-quantity') ? (this.quantity === null ? 'unknown' : this.quantity > 0 ? 'available' : 'unavailable') : 'checking');
        updateProductBanner(this, this.quantity === null ? undefined : this.quantity > 0);
        const row = this.closest('.variant-size-row') || this.parentElement;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.updateAvailability();
        }, { rootMargin: '160px' });
        this.observer.observe(row);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }

      setRowState(state) {
        const row = this.closest('.variant-size-row');
        if (!row) return;
        row.dataset.pickupState = state;
        row.dataset.pickupQuantity = this.quantity === null ? '' : String(this.quantity);
        if (this.hasAttribute('data-stock-column')) {
          this.hidden = false;
          this.textContent = state === 'available' && this.quantity > 0 ? String(this.quantity) : ['unavailable', 'unknown'].includes(state) ? this.dataset.unavailable : this.dataset[state] || this.dataset.checking;
        }
        row.dispatchEvent(new CustomEvent('wsm:pickup-stock', { bubbles: true }));
      }

      async updateAvailability(refresh = false) {
        try {
          this.quantity = await checkStock(this.dataset.variantId, refresh);
          const available = this.quantity === null ? null : this.quantity > 0;
          if (this.isConnected) {
            if (!this.hasAttribute('data-store-banner') && !this.hasAttribute('data-stock-column')) this.hidden = !available;
            this.setRowState(available === null ? 'unknown' : available ? 'available' : 'unavailable');
            updateProductBanner(this, available);
          }
          return available;
        } catch {
          if (this.isConnected) {
            if (!this.hasAttribute('data-store-banner') && !this.hasAttribute('data-stock-column')) this.hidden = true;
            this.setRowState('error');
            updateProductBanner(this, false);
          }
          return null;
        }
      }
    });

    customElements.define('wsm-fulfilment-options', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info') || this.closest('form');
        if (!this.scope || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('change', () => this.updateView(), options);
        this.scope.addEventListener('wsm:pickup-stock', () => this.updateView(), options);
        this.scope.addEventListener('input', () => this.updateView(), options);
        this.mutations = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.variant-size-row') || node.querySelector('.variant-size-row'))))) this.updateView();
        });
        this.mutations.observe(this.scope, { childList: true, subtree: true });
        this.updateView();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.mutations?.disconnect();
      }

      get pickup() { return this.querySelector('input[value="pickup"]').checked; }

      updateView() {
        this.scope.dataset.wsmFulfilment = this.pickup ? 'pickup' : 'delivery';
        this.querySelector('[data-delivery-help]').hidden = this.pickup;
        this.querySelector('[data-pickup-help]').hidden = !this.pickup;
        this.scope.querySelectorAll('.variant-size-row.valid-variant-row').forEach(row => {
          const state = row.dataset.pickupState || 'checking';
          row.dataset.pickupBlocked = String(this.pickup && ['unavailable', 'unknown', 'error'].includes(state));
          const increase = row.querySelector('.qty-btn.plus');
          if (increase) {
            increase.disabled = this.pickup && (state !== 'available' || Number(row.querySelector('input[type="number"]')?.value || 0) >= Number(row.dataset.pickupQuantity));
            increase.title = increase.disabled ? (this.dataset[state] || this.dataset.checking) : '';
          }
        });
        this.updateWarning();
      }

      updateWarning() {
        const invalid = Array.from(this.scope.querySelectorAll('.variant-size-row.valid-variant-row')).some(row => { const qty = Number(row.querySelector('input[type="number"]')?.value || 0); return qty > 0 && (row.dataset.pickupState !== 'available' || qty > Number(row.dataset.pickupQuantity)); });
        this.querySelector('[data-pickup-warning]').hidden = !this.pickup || !invalid;
      }

      async validatePickup(rows) {
        if (!this.pickup || !rows.length) return '';
        if (this.validating) return this.dataset.checking;
        this.validating = true;
        try {
          const states = await Promise.all(rows.map(row => row.querySelector('wsm-in-store-availability')?.updateAvailability(true) ?? Promise.resolve(null)));
          if (!this.pickup) return '';
          if (states.some(state => state === null)) return this.dataset.error;
          return states.every(Boolean) && rows.every(row => Number(row.querySelector('input[type="number"]')?.value || 0) <= Number(row.dataset.pickupQuantity)) ? '' : this.dataset.invalid;
        } finally {
          this.validating = false;
          this.updateView();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wsm-product-ux"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wsm-product-ux')) {
    customElements.define('wsm-product-ux', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.product__info-wrapper') || this.closest('product-info');
        if (!this.scope || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const selectColour = event => {
          if (!this.initialised) return;
          if (event.type !== 'wsm:colour-selected') {
            if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
            if (event.target.closest('.wsm-colour-view-button')) return;
            if (!event.target.closest('.color-tab, .color-tab-wrapper')) return;
          }
          this.scope.classList.remove('wsm-await-colour');
          this.querySelector('[data-wsm-colour-prompt]').hidden = true;
          this.revealSizes();
        };
        ['click', 'keydown', 'wsm:colour-selected'].forEach(type => this.scope.addEventListener(type, selectColour, { signal }));
        const start = () => queueMicrotask(() => {
          if (!this.isConnected || signal.aborted) return;
          this.initialised = true;
          const automatic = this.dataset.showSizesImmediately === 'true';
          this.scope.classList.toggle('wsm-auto-sizes', automatic);
          const hasColourChoice = this.scope.querySelectorAll('.color-tab-wrapper[data-colour-name]').length > 1 || this.scope.querySelectorAll('.color-tab').length > 1;
          this.scope.classList.toggle('wsm-await-colour', !automatic && hasColourChoice);
          this.querySelector('[data-wsm-colour-prompt]').hidden = automatic || !hasColourChoice;
          this.revealSizes();
          this.observer = new MutationObserver(records => {
            if (records.some(record => record.type === 'childList' || record.target.matches('.tab-content, .variant-size-row, .variant-table-header'))) this.revealSizes();
          });
          this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
        else start();
      }
      revealSizes() {
        if (this.dataset.showSizesImmediately !== 'true' || !this.scope) return;
        this.scope.querySelectorAll('.variant-size-row.valid-variant-row').forEach(row => {
          if (row.classList.contains('wsm-size-row-hidden')) row.classList.remove('wsm-size-row-hidden');
          if (!row.classList.contains('wsm-size-row-visible')) row.classList.add('wsm-size-row-visible');
        });
        this.scope.querySelectorAll('.variant-table-header.wsm-table-hidden').forEach(header => header.classList.remove('wsm-table-hidden'));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
        this.initialised = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
